<template>
  <div class="">
    <div class="between_item between_left">
      <LeftCard1></LeftCard1>
      <!-- <LeftCard1 v-if="curSideTab == '电站参观'"></LeftCard1> -->
      <LeftCard2 v-if="curSideTab == '电站运维'"></LeftCard2>
      <div class="side_content">
        <div class="side_item" :class="{ active: isSelected(0) }" @click="handleClickAction(0)">
          开始预演
        </div>
        <div class="side_item" :class="{ active: isSelected(1) }" @click="handleClickAction(1)">
          结束预演
        </div>
      </div>
    </div>
    <div class="time_line_box" v-if="1 == 2">
      <div class="check_line_box box_style">
        <div class="check_line" v-for="(line, lineIndex) in checkLineList" :key="lineIndex">
          <div class="line_bg" :class="`style1`"></div>
          <div class="line_item_list fb">
            <div
              class="line_item style1"
              v-for="(item, index) in line"
              :class="{ active: index == 2 }"
              :key="index"
            >
              <div class="dot"><span class="dot_around"></span></div>
              <p class="name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftCard1 from './LeftCard1.vue';
import LeftCard2 from './LeftCard2.vue';
let timerVisitView;

export default {
  components: {
    LeftCard1,
    LeftCard2,
  },
  data() {
    return {
      curSideTab: '电站参观',
      selectedTab: null,
      checkLineList: [
        [
          { name: '持续降雨', type: '' },
          { name: '机组开机', type: '' },
          { name: '水位上升', type: '' },
          { name: '机组满负荷发电', type: '' },
          { name: '大坝溢流', type: '' },
          { name: '溢流停止,水位下降', type: '' },
          { name: '机组停止发电', type: '' },
        ],
      ],
    };
  },
  mounted() {
    this.$bus.$on('curSideTab', (data) => {
      console.log('data :>> ', data);
      this.curSideTab = data;
    });
  },
  methods: {
    isSelected(index) {
      return index === this.selectedTab;
    },
    handleClickAction(type) {
      this.selectedTab = type;
      if (type == 1) {
        this.$bus.$emit('isAction', false);

        this.actionStop();
        setTimeout(() => {
          // 停止预演
          this.$Model.i3dActionPreviewOff();
        }, 500);
      }
      if (type == 0) {
        this.$bus.$emit('isAction', true);

        setTimeout(() => {
          // 预演
          this.$Model.i3dActionPreviewOn([1, 1, -1, -1]);
          this.actionStart();
        }, 500);
      }
    },
    actionStart() {
      setTimeout(() => {
        this.$Model.i3dCheckView('09'); //看室外和发电机
      }, 800);
      // 开始预演
      console.log('开始预演 :>> ');
      let count = 0;

      const actionMap = {
        0: [1, 1, -1, -1], //下雨
        1: [3, 1, -1, -1], //
        2: [3, 3, -1, -1], //高水位
        3: [3, 3, 1, -1], //高水位-溢流
        4: [3, 3, 1, -1], //
        5: [3, 3, 1, -1], //
        6: [3, 3, 1, -1], //发电
        7: [3, 3, 1, 1], //发电
      };
      // 06大坝前，08室外 ，09室外和发电机，010大坝后改为高亮水工建筑以及转视角
      timerVisitView = setInterval(() => {
        // if (count == 0) {
        //   this.$Model.i3dCheckView('09'); //看室外和发电机
        // }
        // if (count == 1) {
        //   this.$Model.i3dCheckView('07'); //看水轮机
        // }
        if (count == 1) {
          this.$Model.i3dCheckView('06'); //看大坝前
        }
        // if (count == 3) {
        //   this.$Model.i3dCheckView('010'); //看大坝后
        // }
        if (count == 3) {
          // this.$Model.i3dChangeViewByCode('dz');
          // setTimeout(() => {
          //   this.$Model.i3dHighLight(['SG001'], 'T2', '1', '1'); //高亮水工建筑
          // }, 1000);
          this.$Model.i3dCheckView('010'); //看大坝后
        }
        if (count == 4) {
          this.$Model.i3dCheckView('09'); //看发电机
        }
        setTimeout(() => {
          this.$Model.i3dActionPreviewOn(actionMap[count]);
        }, 1000);
        count++;
        console.log('count :>> ', count);
        if (count == 7) {
          this.actionStop(); //
        }
      }, 3800);
    },
    actionStop() {
      clearInterval(timerVisitView);
      timerVisitView = null;

      console.log('预演终止 :>> ');
    },
  },
  beforeDestroy() {
    setTimeout(() => {
      this.$Model.i3dActionPreviewOn([-1, 1, -1, -1]);
    }, 2000);
    clearInterval(timerVisitView);
  },
};
</script>

<style lang="scss" scoped>
.side_content {
  width: 112px;
  // height: 218px;
  // background: rgb(10, 30, 56, 0.85);
  background: url('../../assets/hs/bg_次级导航背景.png') no-repeat center;
  position: fixed;
  left: 540px;
  background-size: 100% 100%;
  top: 95px;
  z-index: 99;
  .side_item {
    width: 90px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    text-shadow: 0 0 9px #158eff;
    margin: 15px auto;
    cursor: pointer;
    &.active {
      background: url('../../assets/hs/btn次级导航选中.png') no-repeat center;
      color: #fff;
    }
  }
}
.time_line_box {
  position: absolute;
  width: 3200px;
  top: 0;
}
.check_line_box {
  width: 50%;
  position: absolute;
  background: rgb(3 74 144 / 92%);
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  .check_line {
    position: relative;
    .line_bg {
      // width: 374px;
      width: 100%;
      height: 4px;
      background: rgba(6, 107, 209, 0.9);
      box-shadow: inset 0px 0px 51px 0px rgba(16, 84, 144, 0.2);
      border-radius: 2px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 11px;
      &.style1 {
        background: rgba(32, 129, 226, 0.818);
        box-shadow: inset 0px 0px 51px 0px rgba(16, 84, 144, 0.2);
      }
    }
    .line_item_list {
      width: 95%;
      height: 60px;
      margin: auto;
      align-items: center;
      position: relative;
      z-index: 2;
      .line_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        &.active {
          .dot {
            animation: breathe 2s infinite;
            .dot_around {
              background: #accdff;
              box-shadow: 0px 0px 5px 0px rgba(193, 221, 255, 0.95);
            }
          }
        }
        .dot {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          .dot_around {
            display: block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
        }
        .name {
          font-size: 18px;
          font-weight: 500;
        }
        &.style1 {
          .dot {
            background: rgba(189, 228, 255, 0.12);
            box-shadow: inset 0px 0px 3px 0px rgba(65, 217, 251, 0.91);
            border-image: linear-gradient(318deg, rgba(123, 179, 255, 1), rgba(73, 201, 255, 1)) 1 1;
          }
        }
      }
    }
  }
}
@keyframes breathe {
  0% {
    transform: scale(0.9);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.2);
  }
  80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>
